import React from "react";
import { HelpCircle, Bell, Moon, Sun, LogOut, User as UserIcon } from "lucide-react";
import { useTheme } from "../context/ThemeContext";
import { useAuth } from "../context/AuthContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import { Button } from "./ui/button";
import { SidebarToggle } from "./Sidebar";

export default function Header({ onOpenSidebar }) {
  const { theme, toggle } = useTheme();
  const { user, logout } = useAuth();

  return (
    <header className="sticky top-0 z-30 bg-background/80 backdrop-blur border-b border-border">
      <div className="h-16 px-4 md:px-8 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <SidebarToggle onClick={onOpenSidebar} />
        </div>
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="icon" className="text-tiffany-500 hover:text-tiffany-600">
            <HelpCircle size={20} />
          </Button>
          <Button variant="ghost" size="icon" className="text-tiffany-500 hover:text-tiffany-600">
            <Bell size={20} />
          </Button>
          <Button variant="ghost" size="icon" onClick={toggle} className="text-tiffany-500 hover:text-tiffany-600">
            {theme === "dark" ? <Sun size={20} /> : <Moon size={20} />}
          </Button>

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button className="ml-1 rounded-full ring-2 ring-tiffany-200 dark:ring-tiffany-700 hover:ring-tiffany-400 transition">
                <Avatar className="w-9 h-9">
                  {user?.picture && <AvatarImage src={user.picture} alt={user.name} />}
                  <AvatarFallback className="bg-tiffany-500 text-white">
                    {user?.name?.[0] || <UserIcon size={16} />}
                  </AvatarFallback>
                </Avatar>
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56">
              <DropdownMenuLabel>
                <div className="font-semibold">{user?.name}</div>
                <div className="text-xs text-muted-foreground font-normal">{user?.email}</div>
              </DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={logout} className="text-red-600 focus:text-red-600">
                <LogOut size={16} className="mr-2" /> Sair
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
}
